// extracted by mini-css-extract-plugin
module.exports = {"Title":"Footer__Title__[hash_base64-5]","Font":"Footer__Font__[hash_base64-5]"};